import { Box, Flex, Grid, Image } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';

import { useFormikContext } from 'formik';
import { CartridgeModel } from 'src/components/common/CartridgeModel/cartridgeModel';
import { CartridgeInfoType } from '../SetCartridgeType/setCartridgeType';
import { useTranslation } from 'react-i18next';

import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { placeholderUrl } from 'src/config';
import HeaderPromo from './HeaderPromo/headerPromo';

export const SetPromo = () => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setCover.label')}>
					{t('form.steps.setCover.heading')}
				</FormSectionHeading>

				<InputField
					label={t('form.fields.promo')}
					name="media.cover"
					placeholder={placeholderUrl('cover.png')}
					leftText="URL"
					warningText="16:9"
				/>

				<InputField
					label={t('form.fields.promo')}
					name="media.banner"
					placeholder={placeholderUrl('cover.png')}
					leftText="URL"
					warningText="4:3"
				/>

				<FormSectionAddon>
					<Box>{t('form.steps.setCover.desc')}</Box>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<HeaderPromo
					image={(values as any).media.cover}
					smallerImage={(values as any).media.banner}
				/>
			</RightColumn>
		</TwoColumn>
	);
};
